import { Form, Formik } from 'formik';
import { colors } from '../../assets/colors';
import { Text } from '../../helpers';
import Button from '../Button/Button';
import FormField from '../FormField/FormField';
import { BankIDLogo } from '../Logos';
import { useTranslation } from 'react-i18next';

type FormFieldsType = {
    name: string;
    placeholder?: string;
};

type FormPropsType = {
    formTitle?: string;
    initialValues: { [key: string]: string };
    validationSchema: unknown;
    // eslint-disable-next-line
    onFormSubmit: (args: any) => void;
    fields: FormFieldsType[];
    buttonText?: string;
    disabled?: boolean;
    showBankIdLogo?: boolean;
};

const CustomForm = ({
    formTitle,
    initialValues,
    validationSchema,
    onFormSubmit,
    fields,
    buttonText,
    disabled,
    showBankIdLogo = true
}: FormPropsType) => {
    const { t } = useTranslation();

    return (
        <>
            {formTitle && <Text i={formTitle} fontWeight="bold" style={{ marginBottom: '3%' }} />}
            <Formik
                initialValues={initialValues}
                onSubmit={onFormSubmit}
                validationSchema={validationSchema}
            >
                <Form>
                    {fields.map((item) => {
                        return (
                            <FormField
                                key={item.name}
                                name={item.name}
                                placeholder={item.placeholder}
                            />
                        );
                    })}
                    <Button
                        i={buttonText ? buttonText : t('submit')}
                        color={colors.white}
                        fontWeight="bold"
                        style={{
                            marginTop: '8%',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '15px'
                        }}
                        type="submit"
                        disabled={disabled}
                    >
                        {showBankIdLogo && <BankIDLogo />}
                    </Button>
                </Form>
            </Formik>
        </>
    );
};

export default CustomForm;
